<template>
  <!-- Coming soon page-->
  <div>
    
      
    <div
        style="z-index: 10"
        class="loading-overlay"
        
        v-if="ngoInfo && ngoInfo.current_stage < 4"
        
      >
        <h3
          style="z-index: 11; position: absolute; top: 40%; right: 21%"
          class=""
        >
        يمكنك الولوج لهذه الصفحة للإطلاع على سير المعاملة بعد تقديمها 
        </h3>
      </div>
      
      
      <div
        style="z-index: 10"
        class="loading-overlay"
        v-else-if="ngoInfo==null"
        
      >
        <h3
          style="z-index: 11; position: absolute; top: 40%; right: 21%"
          class=""
        >
        يمكنك الولوج لهذه الصفحة للإطلاع على سير المعاملة بعد تقديمها 
        </h3>
      </div>
    
    <h3 class="brand-text mb-2">سير المعاملة</h3>
    <hr />
    <!-- {{transaction}} -->
    <div v-if="loading" class="progress-bar">
      <div class="progress-bar-value"></div>
    </div>
    <show-transaction-flow v-if="transaction" :actionHistories="transaction.actionHistories"></show-transaction-flow>  
    <!-- <div
      v-if="
        !events.accountInfo.length &&
        !events.founders.length &&
        !events.ngoInfo.length
      "
      class="misc-inner mt-2"
    >
      <div class="w-100 text-center">
        <h2 style="opacity: 0.8" class="brand-text my-2">
          يتم تدقيق المعلومات المرسلة .....
        </h2>

        <b-img fluid :src="imgUrl" alt="Coming soon page" />
      </div>
    </div>
    <div v-else>
      <div class="mb-2">
        <h4>سجل معلومات الحساب</h4>
        <hr />
        <ministry-log :events="accLog" />
      </div>
      <div class="mb-2">
        <h4>سجل معلومات المنظمة</h4>
        <hr />
        <ministry-log :events="ngoLog" />
      </div>
      <div class="mb-2">
        <h4>سجل معلومات الأعضاء</h4>
        <hr />
        <ministry-log :events="memLog" />
      </div>
    </div> -->
  </div>
  <!-- / Coming soon page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BForm, BFormInput, BButton, BImg } from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import store from "@/store/index";
import { mapGetters , mapActions } from "vuex";
import MinistryLog from "../../components/MinistryLog.vue";
import {ShowTransactionFlow} from "@/modules/ngo/transactions/components";
export default {
  components: {
    VuexyLogo,
    BLink,
    BForm,
    BButton,
    BFormInput,
    BImg,
    MinistryLog,
    ShowTransactionFlow
  },
  data() {
    return {
      downImg: require("@/assets/images/pages/coming-soon.svg"),
    };
  },
  mounted() {
    if (this.ngoInfo && this.ngoInfo.current_stage >=4){
      this.fetchTransaction()
    }
  },
  methods: {
    ...mapActions("TempNgo/Track", ["fetchTransaction"]),
    getLogMessage(logItem, type, member = null) {
      var op =
        logItem.action_type === "processing"
          ? "تم إضافة تعليق"
          : logItem.action_type === "authenticated"
          ? "تم المصادقة"
          : "تم إلغاء المصادقة";

      var model =
        type === "acc"
          ? "على معلومات الحساب"
          : type === "ngo"
          ? "على معلومات المنظمة"
          : "على معلومات العضو";
      var mem = member ? `"${member}"` : "";

      return `${op} ${model} ${mem}`;
    },
  },
  computed: {
    ...mapGetters("TempNgo", ["events" , "ngoInfo"]),
    ...mapGetters("TempNgo/Track", ["transaction" , "loading"]),
    accLog() {
      return this.events.accountInfo.map((el) => {
        return {
          ...el,
          message: this.getLogMessage(el, "acc"),
        };
      });
    },
    ngoLog() {
      return this.events.ngoInfo.map((el) => {
        return {
          ...el,
          message: this.getLogMessage(el, "ngo"),
        };
      });
    },
    memLog() {
      if (this.events.founders) {
        var allhistory = [];
        this.events.founders.forEach((el) => {
          el.history.forEach((action) => {
            var x = {
              name: el.name,
              ...action,
              message: this.getLogMessage(action, "mem", el.name),
            };
            allhistory.push(x);
          });
        });
        const sortedArray = allhistory.sort(
          (a, b) =>
            new this.$moment(a.created_at) - new this.$moment(b.created_at)
        );
        return sortedArray;
      }
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require("@/assets/images/pages/coming-soon-dark.svg");
        return this.downImg;
      }
      return this.downImg;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
